export class DateTimeFormat {
	public static germanDateFormat(date: string): string {
		const year = date.split('-')[0];
		const month = date.split('-')[1];
		const day = date.split('-')[2];
		return `${day}.${month}.${year}`;
	}

	public static dateFormatDE(date: string) {
		const year = date.split('-')[0];
		const month = date.split('-')[1];
		const formatDE = `EZ ${month}/${year}`;
		return formatDE;
	}
}
